export function temPermissao(
  permissoes: any,
  modulo: string,
  acao: string
): boolean {
  return permissoes?.[modulo]?.[acao] === "sim";
} 